import { createContext, useContext } from "react";
import type { LocalStorageTokenData } from "../../utils/localStorage/localStorage.types";

export const UserContext = createContext<
  { user: LocalStorageTokenData; token: string } | undefined
>(undefined);

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) throw new Error("UserProvider is required");
  return context;
};

export const useCurrentUser = () => useUserContext().user;
